import { render } from "./SlideOverWeekFilter.vue?vue&type=template&id=5a0b1f61&scoped=true"
import script from "./SlideOverWeekFilter.vue?vue&type=script&lang=js"
export * from "./SlideOverWeekFilter.vue?vue&type=script&lang=js"

import "./SlideOverWeekFilter.vue?vue&type=style&index=0&id=5a0b1f61&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0b1f61"]])

export default __exports__